import MinusIcon from '@atlaskit/icon/core/minus';
import React from 'react';

export const SvgMinus = () => (
  <MinusIcon label="" testId="ads-refreshed-icon" />
);
